import { Main } from './main';
import { Injector } from '@components';

Injector(Main, document.getElementById('cbfwyrwizard'), { label: 'CBF-WYR-WIZARD' });
